var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4449 23.3333V14.203C24.4449 13.5677 24.3215 12.9392 24.0821 12.3558C23.8427 11.7724 23.4924 11.2465 23.0527 10.8103L14.8604 2.68095C14.4478 2.27137 13.9016 2.04315 13.3338 2.04315C12.766 2.04315 12.2197 2.27137 11.8071 2.68095L3.61488 10.8103C3.17513 11.2465 2.82483 11.7724 2.58543 12.3558C2.34604 12.9392 2.22259 13.5677 2.22266 14.203V23.3333C2.22266 23.9521 2.45678 24.5456 2.87353 24.9832C3.29028 25.4208 3.85551 25.6666 4.44488 25.6666H22.2227C22.812 25.6666 23.3773 25.4208 23.794 24.9832C24.2108 24.5456 24.4449 23.9521 24.4449 23.3333Z",
    stroke: "#616161",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.888ede4c4224ecf4b8fabe5899560ed3.svg";
export { ForwardRef as ReactComponent };